import { createAction } from '@reduxjs/toolkit';
import { IUser } from '../../models/user.model';
const AuthActionTypes = Object.freeze({
  SET_USER: 'auth/SET_USER',
  SET_READY: 'auth/SET_READY',
  SET_AUTH: 'auth/SET_AUTH',
} as const);

type AuthActionTypes = Enum<typeof AuthActionTypes>;

const setUser = createAction<IUser | undefined | null>(
  AuthActionTypes.SET_USER,
);

const setReady = createAction<boolean>(AuthActionTypes.SET_READY);
const setAuth = createAction<boolean>(AuthActionTypes.SET_AUTH);

const AuthActions = Object.freeze({
  setUser,
  setReady,
  setAuth
});

export default AuthActions;
